import React from 'react'
import MainLayout from '../components/layout'
import styled from '@emotion/styled'
import {Seo} from '../components/Seo'

const AboutMeStyles = styled.div`
  padding: 20px;
  height: 100vh;

  .heading {
    color: ${props => props.theme.colors.secondary};
  }

  a {
    color: ${props => props.theme.colors.secondary};
    &:hover {
      text-decoration: underline;
    }
  }
`

export default function Contact () {
  return <MainLayout>
    <AboutMeStyles>
      <h1 className='heading'>Contact me</h1>
      <p>
        You can reach me using any of my social accounts or alternatively{' '}
        <a href='mailto:9pitops@gmail.com'>here</a>
      </p>
    </AboutMeStyles>
    <Seo path='/about' for='page' />
  </MainLayout>
}

